import { LANGUAGE_CONFIG, type SupportedLanguage } from "../config/languages";

import { LanguageResolver } from "./languageResolver";

type DetectionParams = {
  /** 1. バックエンドサーバのセッションロケール (最優先) */
  sessionLocale: string | null | undefined;
  /** 2. AuthStoreの設定（ユーザーが明示的に選択した言語） */
  clientLocale: SupportedLanguage | null | undefined;
  /** 3. ブラウザの言語設定 (最後の候補) */
  browserLanguage: string;
  config: typeof LANGUAGE_CONFIG;
};

type DetectionResult = {
  detectedLanguage: SupportedLanguage;
};

export class LanguageDetection {
  /**
   * 言語検出の結果を生成
   *
   * README.md記載の優先順位に従って言語を決定
   */
  static createDetectionResult({
    sessionLocale,
    clientLocale,
    browserLanguage,
  }: DetectionParams): DetectionResult {
    const detectedLanguage = LanguageResolver.resolve({
      sessionLocale,
      clientLocale,
      browserLanguage,
      supportedLanguages: LANGUAGE_CONFIG,
    });

    return {
      detectedLanguage,
    };
  }
}
